<template>

  <div>
    <CaricoUploadSSCCEdit :showUploadEditSSCCDialog="showUploadEditSSCCDialog"
                          @close-sscc-edit="showUploadEditSSCCDialog = false"
                          v-bind:uploadEditSSCData="uploadEditSSCData"
                          v-on:save-sscc-row="onSavePalletRow"></CaricoUploadSSCCEdit>
    <form novalidate class="md-layout">
      <md-card class="md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title">Ordine di carico</div>
        </md-card-header>
        <md-card-content>
          <div v-show="!uploadCompleted">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-40">
                <md-field>
                  <label>Seleziona i file</label>
                  <md-file v-model="file.name" @md-change="onFileUpload($event)" accept="application/pdf" />
                </md-field>
                <md-button class="md-raised" v-on:click="uploadFile()">Carica</md-button>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-40" v-show="uploading">
                <md-progress-bar md-mode="indeterminate"></md-progress-bar>
              </div>
            </div>
          </div>
          <div v-show="uploadCompleted">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-30">
                <md-vuelidated>
                  <label for="deliveryNote">Delivery note</label>
                  <md-input type="text" v-model="fields.deliveryNote" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-30">
                <md-vuelidated>
                  <label for="elogate">ELOGATE</label>
                  <md-input type="text" v-model="fields.elogate" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-vuelidated field="md-datepicker" class="maxwidth220" v-model="fields.orderDate" md-immediately>
                  <label for="orderDate">Order Date</label>
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-vuelidated field="md-datepicker" class="maxwidth220" v-model="fields.deliveryDate" md-immediately>
                  <label for="deliveryDate">Delivery Date</label>
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-vuelidated>
                  <label for="transportMean">Transport mean</label>
                  <md-input type="text" v-model="fields.transportMean" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <div class="field-wrapper">
                  <md-vuelidated>
                    <label for="grossWeight">Gross weight</label>
                    <md-input v-model="fields.grossWeight.quantity" separator="." v-bind:precision="2"></md-input>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>

                  <md-vuelidated>
                    <md-select v-model="fields.grossWeight.unit" name="grossWeightUnit" id="grossWeightUnit">
                      <md-option value="KG">KG</md-option>
                    </md-select>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <div class="field-wrapper">
                  <md-vuelidated>
                    <label for="netWeight">Net weight</label>
                    <md-input v-model="fields.netWeight.quantity" separator="." v-bind:precision="2"></md-input>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                  <md-vuelidated>
                    <md-select v-model="fields.netWeight.unit" name="netWeightUnit" id="netWeightUnit">
                      <md-option value="KG">KG</md-option>
                    </md-select>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                </div>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-vuelidated>
                  <label for="depot">Magazino</label>
                  <md-select name="depot" v-model="fields.depot">
                    <md-option v-for="(item, idx) in depots"
                               v-bind:key="idx"
                               :value="idx"><span v-html="item"></span>
                    </md-option>
                  </md-select>
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  <md-vuelidated-msg constraint="notEmpty">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-vuelidated>
                  <label for="pos">Pos</label>
                  <md-input type="text" v-model="fields.pos" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-vuelidated>
                  <label for="numeroMagazzino">Numero magazino</label>
                  <md-input type="text" v-model="fields.numeroMagazzino" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
            </div>
            <div class="md-layout">
              <md-toolbar md-elevation="0">
                <h3 class="md-title" style="flex: 1">Dettaglio</h3>
                <md-button class="md-icon-button" @click="addRow()">
                  <md-icon>add</md-icon>
                </md-button>
              </md-toolbar>
              <md-table class="fullScreen">
                <md-table-row>
                  <md-table-head>POS</md-table-head>
                  <md-table-head>Mat. Number</md-table-head>
                  <md-table-head class="desc">Description</md-table-head>
                  <md-table-head>Pcs/Unit</md-table-head>
                  <md-table-head>Packaging amount</md-table-head>
                  <md-table-head>Quantity</md-table-head>
                  <md-table-head>Weight</md-table-head>
                  <md-table-head class="action">&nbsp;</md-table-head>
                </md-table-row>
                <template v-for="(row, index) in fields.details">
                    <md-table-row :key="row.pos">
                      <md-table-cell md-numeric>{{row.pos}}</md-table-cell>
                      <md-table-cell>{{row.materialNumber}}</md-table-cell>
                      <md-table-cell  class="desc">{{row.description}}</md-table-cell>
                      <md-table-cell>{{row.pcsUnit.quantity}} / {{row.pcsUnit.unit}}</md-table-cell>
                      <md-table-cell>{{row.packagingAmount.quantity}} / {{row.packagingAmount.unit}}</md-table-cell>
                      <md-table-cell>{{row.quantity.quantity}} / {{row.quantity.unit}}</md-table-cell>
                      <md-table-cell>{{row.weight.quantity}} / {{row.weight.unit}}</md-table-cell>
                      <md-table-cell>
                        <md-button class="md-icon-button" @click="onEditRow(row)">
                          <md-icon>edit</md-icon>
                        </md-button>
                        <md-button class="md-icon-button" @click="print(row)">
                            <md-icon>print</md-icon>
                        </md-button>
                      </md-table-cell>
                    </md-table-row>
                    <md-table-row :key="row.pos" class="sscc">
                      <md-table-cell colspan="8">
                        <div class="ssccToolbar">
                          <strong>SSCC No.:</strong>
                          <md-button class="md-icon-button md-dense" @click="addSSCC(index)">
                            <md-icon>add</md-icon>
                          </md-button>
                        </div>
                        <div class="ssccList">
                          <div class="ssccNumber" v-for="(sscc, idx) in row.ssccNumber" :key="sscc.number" :class="{'broken' : sscc.rotto}">
                            <span>{{sscc.pallet}}</span>
                            <span>
                              <md-button class="md-icon-button md-dense" @click="brokenSSCC(index, idx, sscc)">
                                <md-icon>broken_image</md-icon>
                              </md-button>
                              <md-button class="md-icon-button md-dense" @click="removeSSCC(index, idx)">
                                <md-icon>delete</md-icon>
                              </md-button>
                              <md-button class="md-icon-button md-dense" @click="editSSCC(index, idx, sscc)">
                                <md-icon>edit</md-icon>
                              </md-button>
                            </span>
                          </div>
                        </div>
                      </md-table-cell>
                    </md-table-row>
                  </template>
              </md-table>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button type="button"
                     class="md-primary md-raised"
                     :disabled="saving"
                     v-show="uploadCompleted"
                     @click="save()">Conferma</md-button>
          <md-button type="button" class="md-primary" :disabled="saving" @click="abort()">Annulla</md-button>
        </md-card-actions>
      </md-card>
      <md-dialog :md-active.sync="editRow" v-on:md-clicked-outside="onCancelEditRow()">
        <md-dialog-title>Pos. {{rowData.pos}}</md-dialog-title>
        <md-dialog-content>
          <md-field>
            <label for="row">Material number</label>
            <md-input name="materialNumberRow" id="materialNumberRow" v-model="rowData.materialNumber" />
          </md-field>
          <md-field class="minwidth300">
            <label for="row">Description</label>
            <md-input name="descriptionRow" id="descriptionRow" v-model="rowData.description" />
          </md-field>
          <div class="field-wrapper">
            <md-field>
              <label for="row">Pieces</label>
              <md-input name="pcsUnitRow" id="pcsUnitRow" v-model="rowData.pcsUnit.quantity" />
            </md-field>
            <md-field>
              <md-select v-model="rowData.pcsUnit.unit" name="pcsUnitUnitRow" id="pcsUnitUnitRow">
                <md-option value="PAL">PAL</md-option>
                <md-option value="PC">PC</md-option>
                <md-option value="KG">KG</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="field-wrapper">
            <md-field>
              <label for="row">Packaging Amount</label>
              <md-input name="packagingAmountRow" id="packagingAmountRow" v-model="rowData.packagingAmount.quantity" />
            </md-field>
            <md-field>
              <md-select v-model="rowData.packagingAmount.unit" name="packagingAmountUnitRow" id="packagingAmountUnitRow">
                <md-option value="PAL">PAL</md-option>
                <md-option value="PC">PC</md-option>
                <md-option value="KG">KG</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="field-wrapper">
            <md-field>
              <label for="row">Quantity</label>
              <md-input name="quantityRow" id="quantityRow" v-model="rowData.quantity.quantity" />
            </md-field>
            <md-field>
              <md-select v-model="rowData.quantity.unit" name="quantityUnitRow" id="quantityUnitRow">
                <md-option value="PAL">PAL</md-option>
                <md-option value="PC">PC</md-option>
                <md-option value="KG">KG</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="field-wrapper">
            <md-field>
              <label for="row">Weight</label>
              <md-input name="weightRow" id="weightRow" v-model="rowData.weight.quantity" />
            </md-field>
            <md-field>
              <md-select v-model="rowData.weight.unit" name="weightUnitRow" id="weightUnitRow">
                <md-option value="PAL">PAL</md-option>
                <md-option value="PC">PC</md-option>
                <md-option value="KG">KG</md-option>
              </md-select>
            </md-field>
          </div>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary md-raised" @click="onConfirmEditRow()">Aggiorna</md-button>
          <md-button class="md-primary" @click="onCancelEditRow()">Annulla</md-button>
        </md-dialog-actions>
      </md-dialog>
  </div>

</template>
<script>

  import moment from 'moment'
  import axios from 'axios'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  import CaricoUploadSSCCEdit from './CaricoUploadSSCCEdit.vue'

  const instance = axios.create({
    baseURL: window.appCfg.serviceURI
  })

  instance.interceptors.request.use(config => {
    config.headers.common['Access-Control-Allow-Origin'] = '*'
    return config
  })

  //const mockup = {


  export default {
    name: 'CaricoUpload',
    mixins: [validationMixin],
    components: {
      CaricoUploadSSCCEdit
    },
    data: function() {
      return {
        showUploadEditSSCCDialog: false,
        uploadEditSSCData: {
          id: 0,
          rowId: 0,
          number: '',
          pallet: '',
          rotto: false
        },
        depots: {},
        uploadCompleted: false,
        file: { name: '' },
        rowData: {
          pos: '',
          materialNumber: '',
          description: '',
          pcsUnit: {
            quantity: '',
            unit: ''
          },
          packagingAmount: {
            quantity: '',
            unit: ''
          },
          quantity: {
            quantity: '',
            unit: ''
          },
          weight: {
            quantity: '',
            unit: ''
          },
          ssccNumber: []
        },
        fields: {
          details: [],
          orderDate: new Date(),
          deliveryDate: new Date(),
          deliveryNote: '',
          transportMean: '',
          pos: '',
          depot: 0,
          numeroMagazzino: '',
          elogate : '',
          grossWeight: {
            quantity: '',
            unit: ''
          },
          netWeight: {
            quantity: '',
            unit: ''
          }
        },
        uploading: false,
        editRow: false
      }
    },
    validations: {
      fields: {
        deliveryNote: {
          required
        },
        elogate: {
          required
        },
        pos: {
          required
        },
        depot: {
          required,
          notEmpty : function(value) {
            return parseInt(value) > 0
          }
        },
        numeroMagazzino: {
          required
        },
        orderDate: {
          required
        },
        deliveryDate: {
          required
        },
        transportMean: {
          required
        },
        grossWeight: {
          quantity: {
            required
          },
          unit: {
            required
          }
        },
        netWeight: {
          quantity: {
            required
          },
          unit: {
            required
          }
        }
      }
    },
    mounted() {
      this.depots = window.appCfg.depots
      if (this.$route.params.id !== undefined) {
        let params = {
          action: 'load',
          id: this.$route.params.id
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/carico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.uploadCompleted = true
              this.fields = response.data.data
              // Converto in data
              this.fields.orderDate = new Date(this.fields.orderDate)
              this.fields.deliveryDate = new Date(this.fields.deliveryDate)
            } else {
              this.$fire({
                html: 'Errore di sistema: ' + response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
      }
    },
    methods: {
      abort() {
        this.$fire({
          title: '',
          html: "Annullare tutte le modifiche?",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Conferma'
        }).then(result => {
          if (result.value) {
            this.$router.push('/carico')
          }
        })
      },
      onFileUpload(evt) {
        this.file = evt[0]
      },

      uploadFile: function() {
        this.uploading = true
        // this.pdftojson = ["Attendi la conversione..."]
        let formData = new FormData()
        formData.append('file', this.file)
        instance
          .post('/uploadconvertpdf', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.uploading = false

//            if (window.appCfg.mockup) response = mockup

            if (
              response.status == 200 &&
              response.data.object &&
              response.data.object.length == 1 &&
              response.data.object[0].deliveryNote != null
            ) {
              this.uploadCompleted = true

              // Aggiungo flag rotto
              for (var k in response.data.object[0].details)
                for (var y in response.data.object[0].details[k].ssccNumber)
                  response.data.object[0].details[k].ssccNumber[y].rotto = false

              // Add campi solo gestionale
              response.data.object[0].pos = ''
              response.data.object[0].numeroMagazzino = ''
              response.data.object[0].depot = 0
              response.data.object[0].elogate = ''

              // Converto in data
              response.data.object[0].orderDate = new Date(response.data.object[0].orderDate)
              response.data.object[0].deliveryDate = new Date(response.data.object[0].orderDate)

              for (var k in response.data.object[0]) this.fields[k] = response.data.object[0][k]

            } else {
              this.$fire({
                html: response.statusText ? response.statusText : 'Errore durante la conversione del file',
                type: 'error'
              })
            }
          })
          .catch(response => {
            this.uploading = false
            this.uploadCompleted = false
            this.$fire({
              html: 'Errore di sistema',
              type: 'error'
            })
          })
      },
      print(row) {
        axios.get('/print/etichetta').then(response => {
          if (response.data) {
            response.data = response.data.replace('{DN}', this.fields.deliveryNote)
            response.data = response.data.replace('{POS}', this.fields.pos)
            response.data = response.data.replace('{MN}', row.materialNumber)
            response.data = response.data.replace('{TIPO}', row.description)
            response.data = response.data.replace('{DATA}', this.fields.orderDate)
            response.data = response.data.replace('{DEP}', this.depots[this.fields.depot])
            response.data = response.data.replace('{NUMMAG}', this.fields.numeroMagazzino)

            document.getElementById('print-container').innerHTML = response.data
            printJS({ printable: 'print-container', type: 'html', documentTitle: '', header: '' })
          }
        })
        // .catch(function (error) {
        //   this.$fire({
        //     html: 'Errore di sistema',
        //     type: 'error'
        //   })
        // })
      },
      onEditRow(row) {
        this.editRow = true
        this.rowData = JSON.parse(JSON.stringify(row))
      },
      onConfirmEditRow() {
        this.editRow = false
        for (var i = 0, iLen = this.fields.details.length; i < iLen; i++) {
          if (this.fields.details[i].pos === this.rowData.pos) {
            this.fields.details[i] = this.rowData
            break
          }
        }
      },
      onCancelEditRow() {
        this.editRow = false
      },
      save(e) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }

        // Formatto le date per PHP
        this.fields.orderDate = moment(String(this.fields.orderDate)).format('YYYY-MM-DD')
        this.fields.deliveryDate = moment(String(this.fields.deliveryDate)).format('YYYY-MM-DD')

        let params = {
          action: 'save',
          what: 'full',
          data: this.fields
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/carico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.$fire({
                html: 'Ordine di carico salvato',
                type: 'success',
                showCloseButton: true,
                showCancelButton: false
              }).then(r => {
                this.$router.push('/carico')
              })
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
          .catch(function(error) {
            this.$fire({
              html: 'Errore di sistema: ' + error.response,
              type: 'error'
            })
          })
      },
      addSSCC(detailIndex) {
        this.uploadEditSSCData = {
          id: -1,
          rowId: detailIndex,
          number: '',
          pallet: '',
          rotto: false
        }
        this.showUploadEditSSCCDialog = true
      },
      editSSCC(detailIndex, ssccIndex, row) {
        this.uploadEditSSCData = {
          id: ssccIndex,
          rowId: detailIndex,
          number: row.number,
          pallet: row.pallet,
          rotto: row.rotto
        }
        this.showUploadEditSSCCDialog = true
      },
      brokenSSCC(detailIndex, ssccIndex, row) {
        row.rotto = !row.rotto
      },
      removeSSCC(detailIndex, ssccIndex) {
        this.$fire({
          title: 'Cancellare il pallet?',
          html: "Non sar&agrave; possibile annullare l'operazione",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Cancella'
        }).then(result => {
          if (result.value) {
            this.fields.details[detailIndex].ssccNumber.splice(ssccIndex, 1)
          }
        })
      },
      onSavePalletRow: function(data) {
        this.showUploadEditSSCCDialog = false
        if (data.id == -1) {
          this.fields.details[data.rowId].ssccNumber.push(JSON.parse(JSON.stringify(data)))
        } else {
          this.fields.details[data.rowId].ssccNumber[data.id] = JSON.parse(JSON.stringify(data))
        }
      }
    }
  }

</script>

<style>

  .md-content.fullScreen {
    width: 100%;
    max-width: 100%;
    padding: 10px 0;
  }
  .md-table .md-table-content {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }
  .desc {
    max-width: 320px;
  }
  tr.md-table-row > td {
    text-align: left;
  }
  .sscc > td {
    border-top: 0px !important;
  }
  .ssccList {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .ssccNumber {
    max-width: 150px;
    width: 150px;
    text-align: left;
  }
  .md-field .md-error {
    display: block !important;
    left: 0;
    opacity: 0;
    transform: translate3d(0, -8px, 0);
  }
  .md-field .md-count,
  .md-field .md-error,
  .md-field .md-helper-text {
    height: 20px;
    position: absolute;
    bottom: -22px;
    font-size: 12px;
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .md-field.md-invalid .md-error {
    opacity: 1;
    transform: translateZ(0);
  }
  .md-invalid .md-error,
  .md-invalid label {
    color: #ff1744;
  }
  .field-wrapper {
    display: flex;
    max-width: 220px;
    width: 100%;
    justify-content: space-between;
  }
  .field-wrapper > .md-field:first-child {
    max-width: 65%;
  }
  .field-wrapper > .md-field:last-child {
    max-width: 25%;
  }

</style>



// WEBPACK FOOTER //
// src/components/CaricoUpload.vue